import { DropDownProps, Dropdown } from "antd";

import "./style.scss";
const CustomDropdown = (props: DropDownProps) => {
  return (
    <Dropdown
      trigger={["click", "hover"]}
      overlayStyle={{ minWidth: "216px" }}
      {...props}
      menu={{
        ...props.menu,
        className: "custom-dropdown-menu",
      }}
    >
      {props.children}
    </Dropdown>
  );
};

export default CustomDropdown;
